var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserVneck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3C2.5 1.35938 3.83594 0 5.5 0C7.14062 0 8.5 1.35938 8.5 3C8.5 4.66406 7.14062 6 5.5 6C3.83594 6 2.5 4.66406 2.5 3ZM7.75 3C7.75 1.75781 6.74219 0.75 5.5 0.75C4.23438 0.75 3.25 1.75781 3.25 3C3.25 4.24219 4.23438 5.25 5.5 5.25C6.74219 5.25 7.75 4.24219 7.75 3ZM10.75 11.25C10.75 11.6719 10.3984 12 10 12H1C0.578125 12 0.25 11.6719 0.25 11.25V11.0625C0.25 9.11719 1.67969 7.47656 3.55469 7.19531L5.5 9.75L7.42188 7.19531C9.29688 7.47656 10.75 9.11719 10.75 11.0625V11.25ZM3.25 8.01562C1.9375 8.41406 1 9.63281 1 11.0625V11.25H10V11.0625C10 9.63281 9.03906 8.41406 7.72656 8.01562L6.08594 10.2188C5.94531 10.4062 5.73438 10.5 5.5 10.5C5.24219 10.5 5.03125 10.4062 4.89062 10.2188L3.25 8.01562Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVneck);
export default __webpack_public_path__ + "static/media/user-vneck.24b413821335914815ead6a7a30c770b.svg";
export { ForwardRef as ReactComponent };